import styled from 'styled-components'
import GridCheckbox from '../../../ui/check-box/GridCheckbox'

/** Read-only boolean display. Editing happens through the row's edit flow, not here. */
export const CheckboxCell = ({ checked }: { checked: boolean }) => (
  <Wrap>
    <GridCheckbox checked={checked} readOnly tabIndex={-1} />
  </Wrap>
)

export default CheckboxCell

const Wrap = styled.span`
  display: inline-flex;
  pointer-events: none;
`
